export default __webpack_public_path__ + "static/media/ser2.a5639279.svg";